import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { filter, takeUntil, takeWhile } from 'rxjs/operators';
import { BehaviorSubject, Observable, timer } from 'rxjs';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';

@Component({
  selector: 'livematch-component',
  templateUrl: '../sharedTemplates/livematch.component.html',
})
export class LiveMatchComponent implements AfterViewInit, OnChanges {
  constructor(
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    public _Router: Router
  ) {
    this.favoriteList = this._DataHelper.getLiveFavoriteTournamentData();

    this.subscribeWindowSize = this._UiHelper.windowResized.subscribe(c => {
      this.styles.vScrool.height = this._UiHelper.windowsHeight - 260 + 'px';

      if (this.liveHeight.height == 'auto') {
        this.styles.vScrool.height = 'auto';
      }

      //// console.warn("windowResized", this.styles.vScrool.height);
    });
    this.styles.vScrool.height = this._UiHelper.windowsHeight - 260 + 'px';

    // this._UiHelper.documentScrollListener.subscribe((x) => {
    //  ////console.warn("documentScrollListener", x, this._UiHelper.windowsHeight);
    //  if (x >= 75) {
    //    if (this.styles.vScrool.height != (this._UiHelper.windowsHeight - 146) + "px")
    //      this.styles.vScrool.height = (this._UiHelper.windowsHeight - 146) + "px";
    //  }
    //  else if (x == 0){
    //    this.styles.vScrool.height = (this._UiHelper.windowsHeight - 260) + "px";
    //  }
    // });

    // setTimeout(() => {
    //  this._DataHelper.liveDataListener.subscribe(y => {
    //    if (this._flagInitialLiveData > 0) {
    //      const maxitemsize = (this._UiHelper.windowsHeight - 270) / 50;
    //      if (this.__ResultLiveData.length < maxitemsize) {
    //        this.styles.vScrool.height = ((50 * this.__ResultLiveData.length) + 30) + "px";
    //      }
    //      else {
    //        this.styles.vScrool.height = (this._UiHelper.windowsHeight - 270) + "px";
    //      }
    //    }
    //    //this._flagInitialLiveData++;
    //  });

    // },
    //   1500);
  }

  favoriteList: Array<number> = [];

  @Input()
  oddLiveMarketingValue = [0];

  @Input()
  isInitialized = false;

  @Input()
  __ResultLiveData: Observable<any>;

  @Input()
  isFavSection = false;

  @Input()
  isHeaderShow = true;

  @Input()
  _selectedOdds: OddModel[] = [];

  @Input()
  liveHeight = {
    height: '1100px',
  };
  @Input() sportSliderChanges = '';

  @Output() favChanged = new EventEmitter();

  panLeft = '0';

  @Input()
  tippbarstyle = 'tipp-bar';

  isSmallDesktop = false;

  styles = {
    vScrool: { height: this._UiHelper.windowsHeight - 260 + 'px' },
    vScroolFAV: {},
  };

  oddTypes = this._DataHelper.oddTypes;
  _storySportsData = this._DataHelper.storySportsData;

  @ViewChild(VirtualScrollerComponent, { static: false })
  private virtualScroller: VirtualScrollerComponent;

  _flagInitialLiveData = 1;

  subscribeWindowSize;
  subscribeWindowSize2;

  // B3000
  eventDetailEventId = 0;
  eventDetailEventIdOld = 0;

  lastId = 0;

  DEFAULT_SLICE_COUNT = 200;
  sliceCount = this.DEFAULT_SLICE_COUNT;
  lastSportSliderChanges = 0;

  public compareItems(match1: any, match2: any): boolean {
    if (match1 == undefined || match2 == undefined) {
      return true;
    }
    return match1.BetradarMatchId === match2.BetradarMatchId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sportSliderChanges) {
      this.lastSportSliderChanges++;

      this.sliceCount = this.DEFAULT_SLICE_COUNT;
      const executionNumber = this.lastSportSliderChanges;
      timer(1500)
        .pipe(filter(() => executionNumber === this.lastSportSliderChanges))
        .subscribe(() => {
          this.sliceCount = 9999;
        });
    }
  }

  ngAfterViewInit(): void {
    this._UiHelper.windowsWidth < 1400 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
    this.subscribeWindowSize2 = this._UiHelper.windowResized.subscribe(x => {
      this._UiHelper.windowsWidth < 1400 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
      //// console.warn(this._UiHelper.windowsWidth, this.isSmallDesktop);
    });

    if (this.liveHeight.height == 'auto') {
      this.styles.vScrool.height = 'auto';
    }
  }

  ngOnDestroy(): void {
    if (this.subscribeWindowSize != undefined) {
      this.subscribeWindowSize.unsubscribe();
    }

    if (this.subscribeWindowSize2 != undefined) {
      this.subscribeWindowSize2.unsubscribe();
    }
  }

  trackbyMatchID(ix, _data) {
    return _data.BetradarMatchId;
  }

  public trackByFn(index: number, complexItem: any): number {
    // return complexItem.MatchId;
    return complexItem.BetradarMatchId;
  }

  favorableStateChanged(e, _id) {
    this._UserHelper.toogleFavoried(_id);
    this.favChanged.emit();
  }

  goLiveEventDetail(e) {
    this._Router.navigate(['/liveeventdetail', e]);
  }

  clickOdd(oddId) {
    this._ApiService.addLiveOdd(oddId);
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  addOddListener(e) {
    this.clickOdd(e);
  }

  f_storySportsDataImg(e) {
    return this._storySportsData.find(x => {
      return x.SportName === e;
    });
  }

  sportName(e) {
    if (typeof this.oddLiveMarketingValue === 'object') {
      const _a = [];
      this.oddLiveMarketingValue.forEach(_y => {
        Object.prototype.hasOwnProperty.call(this.oddTypes[_y], e) ? _a.push(e) : _a.push('all');
      });
      return _a;
    } else if (typeof this.oddLiveMarketingValue === 'string' || typeof this.oddLiveMarketingValue === 'number') {
      return Object.prototype.hasOwnProperty.call(this.oddTypes[this.oddLiveMarketingValue], e) ? [e] : ['all'];
    }
  }
  // Favori ye Ekle Çıkar
  ToggleFavorites(item) {
    const index = this.favoriteList.indexOf(item.TournamentId);
    if (index > -1) {
      this.favoriteList.splice(index, 1);
    } else {
      this.favoriteList.push(item.TournamentId);
    }
    this._DataHelper.setLiveFavoriteTournamentData(this.favoriteList);
    // this.favorites.emit(this.favoriteList);
  }

  CheckFavorites(dnm) {
    // console.log('')

    if (this._DataHelper.liveFavoriteTournamentList && this._DataHelper.liveFavoriteTournamentList.length > 0) {
      return this._DataHelper.liveFavoriteTournamentList.includes(dnm.TournamentId);
    } else {
      return false;
    }
  }
  eventDetailEventIdListener(e) {
    this.eventDetailEventId = e;

    if (e == this.eventDetailEventIdOld) {
      this.eventDetailEventId = 0;
      this.eventDetailEventIdOld = 0;
    } else {
      this.eventDetailEventIdOld = e;
    }
  }
  ExpansionPanel_Close(id) {
    if (id == this.lastId) {
      this.lastId = 0;
    }
  }
  ExpansionPanel_Open(id) {
    this.lastId = id;
  }

  pairWithMatchID(index: number, event: any) {
    const matchId = event.MatchId && event.EventId;
    return matchId + event.SportNameOriginal;
  }
}

export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}
